import React, { useEffect, useState } from 'react';
import Button from '../../ui/Button';
import MDEditor from '@uiw/react-md-editor';
import { collection, getDocs, doc, updateDoc } from 'firebase/firestore';
import { auth, firestore} from "../../../firebase/firebase.js";
import styles from './SiteInfoAdmin.module.css';
import { useNotifications } from "../../../utils/NotificationContext/NotificationContext";
import LightNav from "./../LightNav/LightNav";
import { useAuth } from "../../../utils/AuthContext/authcontext";
import { Navigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';

export default function SiteInfoAdmin() {
  const [docs, setDocs] = useState({});
  const [loading, setLoading] = useState(true);
  const { notify } = useNotifications();
  const { user, userData, claims } = useAuth(); 
  const { t } = useTranslation(); 

  useEffect(() => {
    async function fetchDocs() {
      const snap = await getDocs(collection(firestore, 'siteInfo'));
      const data = {};
      snap.forEach(d => {
        data[d.id] = d.data().markdown || '';
      });
      setDocs(data);
      setLoading(false);
    }
    fetchDocs();
  }, []);

  const handleSave = async (id) => {
    try {
      await updateDoc(doc(firestore, 'siteInfo', id), { markdown: docs[id] });
      notify('success', `${id} saved!`);
    } catch (err) {
      notify('error', err.message);
    }
  };
  if (!user || claims?.role !== 'admin') {
    return <Navigate to="/home" />;
  }

  if (loading) return <div>{t('ui.loading')}</div>;

  return (
	<>
    <LightNav/>
    <div className={styles.container}>
      <h2>{t('admin.siteInfoTitle')}</h2>
      {Object.keys(docs).map(id => (
        <div key={id} className={styles.section}>
          <h3>{id.replace(/^\w/, c => c.toUpperCase())}</h3>
          <MDEditor height={500} value={docs[id]} onChange={val => setDocs(prev => ({ ...prev, [id]: val }))} />
          <Button variant="primary" onClick={() => handleSave(id)}>{t('admin.save')} {id}</Button>
        </div>
      ))}
    </div>
	</>
  );
}
